// removed by extract-text-webpack-plugin
module.exports = {"SimpleReportBuilder":"SimpleReportBuilder__SimpleReportBuilder__cC38E"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SimpleReportBuilder/SimpleReportBuilder.css
// module id = 565
// module chunks = 0